'use es6';

import http from 'hub-http-rxjs/clients/apiClient';
import { List, Map as ImmutableMap } from 'immutable';
import { map } from 'rxjs/operators/map';
import { ContentTypes, PageState } from '../constants/base';
import Variations from '../models/Variations';
const PAGES_BASE_PATH = 'cospages/v2';
const VARIATION_PROPERTIES = List.of('abStatus', 'analyticsPageId', 'id', 'name', 'url');
const URL = ImmutableMap({
  [ContentTypes.BLOG_POST]: 'blogs/v3/blog-posts',
  [ContentTypes.LANDING_PAGE]: `${PAGES_BASE_PATH}/landing-pages`,
  [ContentTypes.SITE_PAGE]: `${PAGES_BASE_PATH}/site-pages`
});
export default {
  chooseWinner(abTestId, contentType, variationId) {
    const data = variationId;
    return http.post(`${URL.get(contentType)}/end-ab-test/${abTestId}`, {
      data
    });
  },

  createVariation(contentType, id, name) {
    const data = name;
    return http.post(`${URL.get(contentType)}/${id}/create-variation`, {
      data
    });
  },

  fetch(abTestId, contentType) {
    const query = {
      abTestId,
      property: VARIATION_PROPERTIES.toArray()
    };
    return http.get(URL.get(contentType), {
      query
    }).pipe(map(Variations.fromJS));
  },

  rerun(abTestId, contentType, variationId) {
    const data = {
      abTestId,
      newState: PageState.PUBLISHED_AB_VARIANT,
      rerunId: variationId
    };
    return http.post(`${URL.get(contentType)}/rerun-ab-test`, {
      data
    });
  }

};